import React from 'react';
import PropTypes from 'prop-types';
import { Card, IconButton } from 'sa-ui';
import { injectIntl } from 'react-intl';
import messages from './reportsMessages';
import sortBy from 'lodash/sortBy';

import * as helpers from './reportHelpers';

import './RankingStudentCard.scss';

const RankingStudentCard = props => {
  const color = helpers.getColor(props.percentage);

  return (
    <Card className="ranking-student-card">
      <div className="header">
        <div className="student">
          <div className="initials" style={{ backgroundColor: color }}>
            {props.initials}
          </div>
          <div className="student-info">
            <div className="student-name">{props.studentName}</div>
            <div className="student-details">{props.studentInfo}</div>
          </div>
        </div>
        {/* <div className="actions">
          <IconButton
            label={props.intl.formatMessage(messages.see)}
            size={20}
            onClick={props.onRequestSee}
          >
            <i className="ti ti-eye" />
          </IconButton>
        </div> */}
      </div>
      <div className="bar-container">
        <div className="bar" style={{ width: `${props.percentage}%`, backgroundColor: color }} />
        <span style={{ color }}>{props.percentage}</span>
      </div>
      <span className="zero">0</span>
    </Card>
  );
};

RankingStudentCard.propTypes = {};

RankingStudentCard.defaultProps = {
  percentage: 0,
  color: 0,
  index: 0,
};

export default injectIntl(RankingStudentCard);
